import React, {useRef, useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import { Link, useRouteMatch } from 'react-router-dom';
import { Button, Text } from 'ui';
import { useAuth, logout } from 'api';
import "./index.css";


export default function AppNavigation(props) {
  const auth = useAuth();
  const userMenuAnchor = useRef();
  
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const openUserMenu = () => setUserMenuOpen(true);
  const closeUserMenu = () => setUserMenuOpen(false);
  
  const [navMenuOpen, setNavMenuOpen] = useState(false);
  const openNavMenu = () => setNavMenuOpen(true);
  const closeNavMenu = () => setNavMenuOpen(false);
  
  if(!auth) {
    return null;
  }
  
  const width = document.body.scrollWidth;
  
  return (
    <Wrapper>
    
      <Tag style={{marginRight:20}} onClick={openNavMenu}/>
      
      {width > 800 && <NavButton to="/dashboard" label="DASHBOARD"/>}
      {width > 800 && <NavButton to="/campaigns" label="CAMPAIGNS"/>}
      {width > 800 && <NavButton to="/tags" label="NFC TAGS"/>}
      {width > 800 && <NavButton to="/pages" label="LANDING PAGES"/>}
      {width > 800 && <NavButton to="/reports" label="CAMPAIGN ANALYTICS"/>}
      {width > 800 && <NavButton to="/media" label="MEDIA LIBRARY"/>}
      
      
      <div style={{flex:1}}/>
      
      {width > 800 && 
        <Button 
          tertiary 
          style={{paddingLeft:12}} 
          to="/help">
          <svg height="24" viewBox="0 0 24 24" width="24">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path style={{fill:'white'}} d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>
          </svg>
        </Button>
      }
      
      <Button 
        tertiary 
        style={{paddingLeft:12}} 
        ref={userMenuAnchor} 
        onClick={openUserMenu}
        className="navigation-user">
        <Avatar letter={auth.displayName.slice(0, 1)}/>
        <Text white size={12} style={{marginRight:8}}>{auth.displayName}</Text>
        <Caret/>
      </Button>
      
      <UserMenu open={userMenuOpen} onRequestClose={closeUserMenu} anchor={userMenuAnchor}/>
      <NavMenu open={navMenuOpen} onRequestClose={closeNavMenu}/>
    </Wrapper>
  );
}


function Wrapper(props) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handler = () => {
      if(window.scrollY > 24 && !scrolled) {
        setScrolled(true);
      }
      if(window.scrollY < 24 && scrolled === true) {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, [scrolled]);
  
  return (
    <div className="navigation">
      <div 
        className="navigation-inner" 
        style={{
          boxShadow: scrolled ? "0 2px 6px rgba(0,0,0,0.6)" : "0 0px 4px rgba(0,0,0,0.2)",
          ...props.style
        }}>
        {props.children}
      </div>
    </div>
  );
}

function Tag({style, onClick}) {
  return (
    <svg height="20px" viewBox="0 0 52.71 38.49" style={{fill:"#FE5000", flex:'0 0 auto', ...style}} onClick={onClick}>
      <g>
      	<g>
      		<path d="M0.13,14.27c0.73,1.48,1.18,3.12,1.18,4.89c0,1.86-0.5,3.59-1.32,5.13l3.63,3.63 c1.65-2.52,2.62-5.53,2.62-8.76c0-3.13-0.92-6.05-2.48-8.53L0.13,14.27z"/>
      	</g>
      	<g>
      		<path d="M7.33,7.07c2.42,3.42,3.86,7.58,3.86,12.08c0,4.6-1.5,8.84-4.02,12.3l3.52,3.52 c3.39-4.38,5.44-9.86,5.44-15.82c0-5.86-1.98-11.25-5.27-15.6L7.33,7.07z"/>
      	</g>
      	<path d="M14.38,0c4.17,5.26,6.69,11.9,6.69,19.13c0,7.32-2.58,14.05-6.85,19.35v0.02h38.49V0H14.38"/>
      </g>
    </svg>
  );
}

function Avatar({letter}) {
  return (
    <Text
      className="navigation-avatar"
      semibold
      style={{
        width: 24,
        height: 24,
        fontSize: 16,
        lineHeight: '16px',
        backgroundColor: "#00b2a8",
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      {letter}
    </Text>
  );
}

function Caret() {
  return (
    <svg height="6px" viewBox="0 0 9.94 7.56" className="navigation-caret">
      <polyline fill="white" points="9.94,0 4.97,7.56 0,0 "/>
    </svg>
  );
}

function NavButton({to, ...props}) {
  const active = !!useRouteMatch({path:to});
  return (
    <Link to={to} style={{display:'block', textDecoration:'none'}}>
      <Button
        tertiary 
        semibold 
        color="white"
        size={12} 
        style={{
          margin:'0 16px', 
          opacity: !!active ? 1 : 0.8,
          whiteSpace:'nowrap',
        }}
        {...props}
      />
    </Link>
  );
}

function NavMenu({open, onRequestClose}) {
  if(!open) {
    return null;
  }
  
  return ReactDOM.createPortal(
    <div style={{position:'absolute', zIndex:1000, top:0, left:0, bottom:0, right:0}} onClick={onRequestClose}>
      <div 
        style={{
          position: 'absolute', 
          top: 0,
          left: 0,
          bottom: 0,
          paddingTop: 68,
          backgroundColor: 'white',
          minWidth: 200,
          boxShadow: "0 4px 16px rgba(0,0,0,0.3)"
        }}>
        
        <Button block to="/dashboard" label="DASHBOARD"/>
        <Button block to="/campaigns" label="CAMPAIGNS"/>
        <Button block to="/tags" label="TAGS"/>
        <Button block to="/templates" label="TEMPLATES"/>
        <Button block to="/media" label="MEDIA LIBRARY"/>
        <Button block to="/help" label="HELP"/>
        
      </div>
    </div>,
    document.body
  );
}

function UserMenu({open, anchor, onRequestClose}) {
  const auth = useAuth();
  
  if(!open) {
    return null;
  }
  
  const anchorRect = anchor.current.getBoundingClientRect();
  
  return ReactDOM.createPortal(
    <div style={{position:'absolute', zIndex:1000, top:0, left:0, bottom:0, right:0}} onClick={onRequestClose}>
      <div 
        style={{
          position: 'absolute', 
          top: anchorRect.top + anchorRect.height, 
          right: document.body.scrollWidth - anchorRect.right,
          backgroundColor: 'white',
          minWidth: 200,
          boxShadow: "0 4px 16px rgba(0,0,0,0.3)"
        }}>
        {(auth.user.role === "ADMIN") && 
          <Button small block label="Companies" to={`/companies`}/>
        }
        {(auth.user.role === "COMPANY_ADMIN" || auth.user.role === "ADMIN") && 
          <Button small block label="Company Settings" to={`/companies/${auth.company.id}`}/>
        }
        {(auth.user.role === "ADMIN") && 
          <Button small block label="Users" to={`/users`}/>
        }
        <Button small block label="Settings" to={`/users/${auth.user.id}`}/>
        <Button small block label="Log Out" onClick={logout}/>
      </div>
    </div>,
    document.body
  );
}